import { ReactNode } from "react";

export type OpenAIModel = {
  id: string;
  name: string;
  displayText: string,
  displayBadge: string,
  displayBadgeStyle: string,
  iconText?: string,
  iconBadge?: string,
  iconBadgeStyle?: string,
  provider: string;
  maxTokens?: number;
  reasoningEffort?: string[];
  isAvailable: boolean;
  endpoint: string;
  acceptFiles: boolean;
  acceptImages: boolean;
  description?: string;
  inputPrice?: number,
  outputPrice?: number,
};


export interface ChatBody {
  inputCode: string,
  model?: string,
  apiKey?: string | undefined,
  messages?: Message[],
  endpoint: string,
}

export interface AssistantBody {
  inputCode: string,
  model?: string,
  endpoint: string,
  apiKey?: string | undefined,
  maxPromptTokens?: number,
  maxCompletionTokens?: number,
  threadId?: string | undefined | null,
  imageUrls?: FileAndImageUrl[],
  fileUrls?: FileAndImageUrl[],
}

export interface Message {
  role: string,
  content: string,
  id: string,
  messageTimestamp: string,
  model: string,
  annotations?: MessageAnnotation[],
  codeInterpreter?: string,
}



export const ENDPOINTS = {
  OPENAI_CHAT_COMPLETIONS: 'openai-chatCompletions',
  OPENAI_ASSISTANT: 'openai-assistant',
  OPENAI_TTS: 'openai-tts',
}

export interface BeeBotProps {
  apiKeyApp?: string,
  threadId?: string,
  helpRequest?: string,
}

export interface FileAndImageUrl {
  url: string;
  key: string;
}

export interface FileCitation {
  file_id: string;
  quote: string;
  // not provided natively by OpenAI
  file_name?: string,
}

export interface FilePath {
  file_id: string;
  file_name?: string,
}

export type MessageAnnotation = Citation | FilePathAnnotation;

export interface FilePathAnnotation {
  index: number,
  type: "file_path",
  text: string,
  start_index: number,
  end_index: number,
  file_path: FilePath,
  file_name: string,
  // added to replace the original text such as for links to the file download
  new_text?: string,
}

export interface Citation {
  index: number,
  type: 'file_citation',
  text: string,
  start_index: number,
  end_index: number,
  file_citation: FileCitation

  // not provided natively by OpenAI
  citation?: string,
}

export interface TextContent {
  type: "text";
  text: {
    value: string;
    annotations?: MessageAnnotation[];
  };
}